// extracted by mini-css-extract-plugin
module.exports = {"formPhotoContainer":"UserSettings_formPhotoContainer__Ux98h","profilePictureInfo":"UserSettings_profilePictureInfo__1pEqq"};